export type NotificationPriority = 'action' | 'update' | 'fyi';

export interface NotificationItem {
  id: string;
  type: string;
  priority: NotificationPriority;
  title: string;
  body: string;
  href: string;
  createdAt: string;
  alertAt: string;
  read: boolean;
  expired: boolean;
  resolved: boolean;
}

export interface NotificationBanner {
  id: string;
  body: string;
  href: string;
  extra: number;
}

export interface NotificationInbox {
  items: NotificationItem[];
  unreadCount: number;
  banner: NotificationBanner | null;
  nav: { team: boolean; contests: boolean };
}

export interface NotificationPreferences {
  newContests: boolean;
  fillingUp: boolean;
  playersLocked: boolean;
  costlyMoments: boolean;
  rankChanges: boolean;
}

export const EMPTY_INBOX: NotificationInbox = {
  items: [],
  unreadCount: 0,
  banner: null,
  nav: { team: false, contests: false },
};
